<template>
  <div>
    <CCard>
      <CCardHeader>
        {{ $t("New Campaign") }}
        <div class="card-header-actions">
          <CButton
            class="mz-button v2-mz-btn mr-2"
            color="primary"
            @click="createCampaign"
            :disabled="!selected_branch || !start_date || !end_date || !campaign_id"
          >
            {{ $t("Save") }}
            <em class="ml-2 mz-icon icon-save color-inherit"/>
          </CButton>
        </div>
      </CCardHeader>
      <CCardBody>
        <CForm class="d-flex flex-column gap-8">
          <div>
            <label>
              <div class="title">{{ $t("Campaign identification") }}</div>
            </label>
            <div>
              <div class="label">{{ $t("Campaign ID") }}*</div>
              <MzDatePicker
                v-model="campaign_id"
                :config="{ format: 'YYYY', minDate: currentTime }"
                class="input-group"
                placeholder="YYYY"
              />
            </div>
          </div>
          <hr/>
          <div>
            <label>
              <div class="title">{{ $t("Dates") }}</div>
            </label>
            <CRow>
              <CCol col="6" class="p-1">
                <div class="label ml-3">{{ $t("Start Date") }}*</div>
                <MzDatePicker
                  class="input-group ml-3"
                  v-model="start_date"
                  :config="{ format: 'YYYY-MM-DD', minDate: currentTime }"
                  placeholder="YYYY-MM-DD"
                />
              </CCol>
              <CCol col="6" class="p-1">
                <div class="label">{{ $t("Close Date") }}*</div>
                <MzDatePicker
                  class="input-group"
                  v-model="end_date"
                  :config="{ format: 'YYYY-MM-DD', minDate: currentTime }"
                  placeholder="YYYY-MM-DD"
                />
              </CCol>
            </CRow>
          </div>
        </CForm>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import {CampaignServices} from "@/services/campaigns";
import {BranchesServices} from "../../services/branches";
import {ActiveUser} from "../../services/user";
import moment from "moment";
import {getNumericalValue} from "@/utils/helpers";

export default {
  name: "NewCampaign",
  data: function () {
    return {
      getNumericalValue,
      start_date: null,
      end_date: null,
      campaign_id: null,
      currentTime: new Date(),
      rates: [],
      selected_branch: null,
      row_size: 2
    };
  },
  async mounted() {
    this.rates = await BranchesServices.getBranchList()
    this.rates = this.rates.map((rate) => {
      return {
        label: this.$store.state.language == 'en' ? rate.EN : rate.branch,
        id_branch: rate.id_branch,
        value: 0
      }
    })
    if (this.rates.length) {
      this.selected_branch = this.rates[0].id_branch
    } else {
      alert(this.$t("No Branch data. Please create Branch instance before creating new Campaign"), {
              action: {
                  text: this.$t('Close'),
                  icon: 'close',
                  onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                  }
              }
          })

    }
  },
  computed: {
    rates_list_in_rows() {
      const campaign_list_in_rows = []
      for (let i = 0; i < this.rates.length; i += this.row_size) {
        const chunk = this.rates.slice(i, i + this.row_size);
        campaign_list_in_rows.push(chunk)
      }
      return campaign_list_in_rows
    },
  },
  methods: {
    handleRateInput(key_str, v) {
      if(parseFloat(v) === 0) v = '0';
      if (parseFloat(v).toFixed(2) > 100) v = '100'
      if(v !== '0') v = this.getNumericalValue(parseFloat(v))

      this.rates = this.rates.map(rat => ({
        ...rat,
        value: key_str === rat.label ? v : rat.value
      }))
    },
    isStartDateGreaterThanEndDate() {
      return (this.start_date && this.end_date) && (this.start_date >= this.end_date);
    },
    async createCampaign() {
      const today = new Date();
      if (!this.start_date || !this.end_date || !this.campaign_id) {
        alert(this.$t("Please fill all required data"), {
              action: {
                  text: this.$t('Close'),
                  icon: 'close',
                  onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                  }
              }
          });
        return
      }

      if (this.isStartDateGreaterThanEndDate()) {
        alert(this.$t('The closure date should be greater than the start date'), {
              action: {
                  text: this.$t('Close'),
                  icon: 'close',
                  onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                  }
              }
          });
        return
      }

      const {res} = await CampaignServices.createCampaign({
        id_campaign: this.campaign_id,
        id_branch: this.selected_branch,
        date_start: this.start_date,
        date_end: this.end_date,
        date_creation: moment(today).format('YYYY-MM-DD HH:mm:ss'),
        user_creation: ActiveUser?.user?.email,
      });
      if (res.status !== 200) {
        alert(this.$t('Failed to create campaign'), {
              action: {
                  text: this.$t('Close'),
                  icon: 'close',
                  onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                  }
              }
          })
      } else {
        await this.$router.push({
          name: "Campaign Details",
          params: { campaignId: this.campaign_id },
        });
      }
    },
  },
};
</script>

<style lang="scss">
.title {
  font-size: 1.5em;
}

.w-90 {
  width: 90%;
  max-width: 350px;
}

.w-350 {
  max-width: 350px;
}

.input-group {
  max-width: 500px;
}

.arrow-buttons {
  display: none;
}
</style>
